import { FC, useEffect } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectInterstitialImages } from 'store/quiz/quizSelectors';
// Components
import Dialog from 'components/Dialog';

type Props = {
  onClose: () => void;
}

let index = 0;
let timeout:any = null;
const timeoutTime = 2000;

const InterstitialImageDialog:FC<Props> = ({
  // Props
  onClose
}) => {
  // State
  const interstitialImages:any = useAppSelector(selectInterstitialImages);

  useEffect(() => {
    index = interstitialImages.length > 1 ? index === 0 ? 1 : 0 : 0;
    return () => {
      if ( timeout ) clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, []);

  const handleLoad = () => {
    if ( timeout ) clearTimeout(timeout);
    timeout = setTimeout(() => {
      onClose();
    }, timeoutTime);
  }

  return (
    <Dialog>
      <div className="
        flex items-center justify-center
        relative
        w-full h-full
        bg-gradient-animate
      ">
        <img
          className="relative z-10"
          src={interstitialImages[index]}
          onLoad={handleLoad}
          alt=""
        />
      </div>
    </Dialog>
  )
}

export default InterstitialImageDialog;
